import { Link, useParams } from "react-router-dom";

export default function PaidCancel() {
  const { sessionId } = useParams();
  return (
    <div className="sf-container" style={{ padding: "80px 24px", maxWidth: 560 }} data-testid="paid-cancel-page">
      <div className="sf-eyebrow" style={{ marginBottom: 10 }}>Checkout cancelled</div>
      <h1 className="sf-display" style={{ fontSize: 32, marginBottom: 16, lineHeight: 1.15 }}>
        No charge was made.
      </h1>
      <p className="sf-muted-text" style={{ marginBottom: 28 }}>
        Your audit preview is still saved. You can unlock the full report whenever you're ready.
      </p>
      <Link to={`/audit/preview/${sessionId}`} className="sf-btn" data-testid="paid-cancel-back-btn">
        Back to your preview
      </Link>
    </div>
  );
}
